import { Typography, Box, useTheme, Stack } from '@mui/material'
import { StatusChip } from 'components/StatusChip/StatusChip'
import { type FullCheckInPolicy } from 'types/api'

interface ReferralPointsDetailsProps {
  checkInPolicy: FullCheckInPolicy
}

export const ReferralPointsDetails = ({
  checkInPolicy,
}: ReferralPointsDetailsProps) => {
  const theme = useTheme()
  return (
    <Box
      sx={{
        border: 1,
        borderColor: theme.palette.grey[200],
        mt: '16px',
        gap: '16px',
        p: '24px',
      }}
    >
      {checkInPolicy?.enableReferralPoints ? (
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: { xs: 'column' },
            gap: '16px',
          }}
        >
          <Stack spacing={3}>
            <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
              <Typography variant="h4" marginRight={2}>
                Referral Points
              </Typography>
              <StatusChip
                active={!!checkInPolicy?.enableReferralPoints}
                sx={{ maxWidth: '100px' }}
              />
            </Box>
            <Box display={'flex'} flexDirection={'row'}>
              <Box sx={{ flex: 1 }}>
                <Typography variant="body2" pb={1} color="text.secondary">
                  The existing patron referrer will receive{' '}
                  <b>{checkInPolicy?.referralReferrerPoints}</b> extra points
                  upon a referee registering for the app.
                </Typography>
              </Box>
              <Box sx={{ flex: 1 }}>
                <Typography variant="body2" pb={1} color="text.secondary">
                  The new referee will receive{' '}
                  <b>{checkInPolicy?.referralRefereePoints}</b> extra points
                  upon registering for the app.
                </Typography>
              </Box>
            </Box>
          </Stack>
        </Box>
      ) : (
        <Box sx={{ flex: 1 }}>
          <Typography variant="body1" pb={1}>
            Edit to make active
          </Typography>
        </Box>
      )}
    </Box>
  )
}
